import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DataQualityWarningAssetFragmentGql } from './DataQualityWarningAssetFragmentGql';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';

export const DatabaseLineageUpstreamDataQualityWarningsQueryGql: DocumentNode = gql`
  query DatabaseLineageUpstreamDataQualityWarningsQuery($databaseId: ID!, $first: Int!, $offset: Int!, $publishedConnectionsLineageEnabled: Boolean!) {
    databases(filter: { id: $databaseId }) {
      id
      name
      __typename
      dataQualityWarnings {
        isActive
        ...DataQualityWarningFragment
        ...DataQualityWarningAssetFragment
      }
      upstreamDataQualityWarningsConnection (filter: {isActive: true},
                                             first: $first, offset: $offset,
                                             orderBy: {field: IS_SEVERE, direction: DESC}) {
        totalCount
        nodes {
          isActive
          ...DataQualityWarningFragment
          ...DataQualityWarningAssetFragment
        }
      }
    }
  }
  ${DataQualityWarningFragmentGql}
  ${DataQualityWarningAssetFragmentGql}
`;
